import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { useAuthFlowWatcher } from '../features/auth/hooks/useAuthFlowWatcher.ts';
import { useGeoBlockCheck } from '../features/auth/hooks/useGeoBlockCheck.ts';
import { usePrepareAuthPayload } from '../features/auth/hooks/usePrepareAuthPayload.ts';
import { useWalletStateWatcher } from '../features/auth/hooks/useWalletStateWatcher';
import { useDelegatedOwnerCheck } from '../hooks/useDelegatedOwnerCheck.ts';
import useAppStore from '../store/rootStore.ts';
import { telemetry } from '../utils/telemetry';

export const Web3Watchers = () => {
  const { address } = useAccount();
  const setConnectedWalletAddress = useAppStore((state) => state.setConnectedWalletAddress);
  const { connectModalOpen } = useConnectModal();

  useEffect(() => {
    setConnectedWalletAddress(address);
  }, [address, setConnectedWalletAddress]);

  // Funnel entry: every Connect button opens this one RainbowKit modal, so watch it instead of each button.
  useEffect(() => {
    if (connectModalOpen) telemetry.logOnboarding('connect_modal_opened');
  }, [connectModalOpen]);

  useGeoBlockCheck();
  useWalletStateWatcher();
  usePrepareAuthPayload();
  useAuthFlowWatcher();
  useDelegatedOwnerCheck();
  return null;
};
